// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/builds/cloud-collaboration-front/ncc-front/popo-front/popo-meeting-frontend/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/meet/pc/whiteboard",
    "component": require('@/pages/PC/Whiteboard').default,
    "exact": true
  },
  {
    "path": "/meet/pc/note",
    "component": require('@/pages/PC/Note').default,
    "exact": true
  },
  {
    "path": "/meet/pc/recordpanel",
    "component": require('@/pages/PC/RecordPanel').default,
    "exact": true
  },
  {
    "path": "/meet/pc/recordpanel/v2",
    "component": require('@/pages/PC/RecordPanel/v2').default,
    "exact": true
  },
  {
    "path": "/meet/pc/recordpanel/v3",
    "component": require('@/pages/PC/RecordPanel/v3').default,
    "exact": true
  },
  {
    "path": "/meet/pc/recordpanel/v4",
    "component": require('@/pages/PC/RecordPanel/v4').default,
    "exact": true
  },
  {
    "path": "/meet/pc/selectLogin",
    "component": require('@/pages/PC/SelectLogin').default,
    "exact": true
  },
  {
    "path": "/meet/ipad/whiteboard",
    "component": require('@/pages/pad/Whiteboard').default,
    "exact": true
  },
  {
    "path": "/meet/mobile/whiteboard",
    "component": require('@/pages/mobile/Whiteboard').default,
    "exact": true
  },
  {
    "path": "/meet/:meetingId",
    "component": require('@/layouts/index').default,
    "routes": [
      {
        "path": "/meet/:meetingId/meeting",
        "component": require('@/pages/Meeting').default,
        "exact": true
      },
      {
        "path": "/meet/:meetingId/leave",
        "component": require('@/pages/Leave').default,
        "exact": true
      },
      {
        "path": "/meet/:meetingId/feedback",
        "component": require('@/pages/Feedback').default,
        "exact": true
      },
      {
        "path": "/meet/:meetingId/tips",
        "component": require('@/pages/Tips').default,
        "exact": true
      },
      {
        "path": "/meet/:meetingId/forbid",
        "component": require('@/pages/PC/Forbid').default,
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
